import type { IconProps } from "./types";

export function Minus({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9004 0C15.3974 0 15.8008 0.403334 15.8008 0.900391C15.8008 1.39745 15.3974 1.80078 14.9004 1.80078H0.900391C0.403334 1.80078 0 1.39745 0 0.900391C0 0.403334 0.403334 0 0.900391 0H14.9004Z"
        fill={currentColor}
        transform="translate(4.1 11.1)"
      />
    </svg>
  );
}
